import axios from "axios";
import { AUTH_ACTION } from "./Constant";

// entering data to form
export const authAction = (isAuthenticated) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_ACTION, payload: { isAuthenticated } });
  } catch (error) {}
};
